export default "__VITE_ASSET__4e33ff33__"